module.exports = __webpack_public_path__ + "img/camera.194bf836.jpg";